import { asRecordId, getRootCollection } from './queries'

export const listAccountStatuses = () => getRootCollection('accountStatuses')

export const getAccountStatus = (account) =>
  listAccountStatuses().doc(asRecordId(account))
